/**
 * TCGPlayer operator listing helpers.
 *
 * Pokémon and Lorcana singles only. Etched foil is just another printing
 * (its own collector number) and is not a separate gate.
 */

export interface TcgplayerListingSnapshot {
  status?: string | null;
  last_error?: string | null;
  quantity?: string | null;
  price?: string | null;
  updated_at?: string | null;
}

export interface TcgplayerListingCandidate {
  product_line?: string | null;
  product_category?: string | null;
  product_variant_id?: string | null;
}

export function isTcgplayerListingProductLine(productLine?: string | null): boolean {
  const raw = (productLine || '').trim().toLowerCase();
  return raw.includes('pokemon') || raw.includes('pokémon') || raw.includes('lorcana');
}

export function gameDisplayName(productLine?: string | null): string {
  const raw = (productLine || '').trim();
  if (!raw) return '—';
  const folded = raw.toLowerCase();
  if (folded.includes('lorcana')) return 'Lorcana';
  if (folded.includes('pokemon') || folded.includes('pokémon')) return 'Pokémon';
  if (folded.includes('magic')) return 'Magic';
  return raw;
}

export function isTcgplayerListingCandidate(item: TcgplayerListingCandidate): boolean {
  if (!item.product_variant_id) return false;
  // Match shared.lib.card_game.is_single_product_category: blank and sealed are out.
  const category = (item.product_category || '').trim().toLowerCase().replace(/_/g, ' ');
  if (!category || category.includes('sealed') || !category.includes('single')) {
    return false;
  }
  return isTcgplayerListingProductLine(item.product_line);
}
